<template>
  <div class="main-site-layout">
    <router-view></router-view>
  </div>
</template>

<script>
const jsFiles = [
  '/main-site/js/bootstrap.min.js',
  '/main-site/js/jquery.hoverIntent.js',
  '/main-site/js/superfish.min.js',
  '/main-site/js/jquery.sliderPro.min.js',
  '/main-site/js/owl.carousel.min.js',
  '/main-site/js/odometer.min.js',
  '/main-site/js/waypoints.min.js',
  '/main-site/js/jquery.slicknav.min.js',
  '/main-site/js/wow.min.js',
  '/main-site/js/retina.min.js',
  '/main-site/js/custom.js'
];

export default {
  name: 'MainSiteLayout',
  mounted() {
    // Initialize scripts after component is mounted
    // CSS is already injected by router.beforeEach
    this.initializeScripts();
  },
  methods: {
    initializeScripts() {
      // Check if jQuery is already loaded
      if (!window.jQuery) {
        console.warn('jQuery is not available');
        return;
      }

      this.loadScriptsSequentially(jsFiles, 0, () => {
        this.setupMainSiteScripts();
      });
    },
    loadScriptsSequentially(scripts, index, callback) {
      if (index >= scripts.length) {
        callback();
        return;
      }

      this.loadScript(scripts[index], () => {
        this.loadScriptsSequentially(scripts, index + 1, callback);
      });
    },
    loadScript(src, callback) {
      if (document.querySelector(`script[src="${src}"]`)) {
        setTimeout(callback, 50);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        setTimeout(callback, 50);
      };
      script.onerror = () => {
        console.error(`Failed to load script: ${src}`);
        callback();
      };
      script.dataset.layout = 'main-site';
      document.body.appendChild(script);
    },
    setupMainSiteScripts() {
      const $ = window.jQuery;
      if (!$) return;

      // Setup odometer options
      window.odometerOptions = {
        format: 'd'
      };

      // HEADER SLIDER HOOK
      if ($('#index-slider').length) {
        $('#index-slider').fadeIn(1000);
        $('#index-slider').sliderPro({
          width: '100%',
          height: 760,
          arrows: false,
          buttons: true,
          waitForLayers: true,
          fade: true,
          fadeDuration: 800,
          autoplay: true,
          autoplayDelay: 7500,
          autoplayOnHover: 'none',
          autoScaleLayers: false
        });
      }

      // TESTIMONIALS CAROUSEL HOOK
      if ($('#customers-testimonials').length) {
        $('#customers-testimonials').owlCarousel({
          loop: true,
          center: true,
          items: 3,
          margin: 0,
          autoplay: true,
          autoplayTimeout: 8500,
          smartSpeed: 450,
          responsive: {
            0: {
              items: 1
            },
            768: {
              items: 2
            },
            1170: {
              items: 3
            }
          }
        });
      }

      // CLIENTS CAROUSEL HOOK
      if ($('#clients-carousel').length) {
        $('#clients-carousel').owlCarousel({
          loop: true,
          items: 5,
          margin: 30,
          autoplay: true,
          autoplayTimeout: 8500,
          smartSpeed: 450,
          responsive: {
            0: {
              items: 2
            },
            768: {
              items: 3
            },
            1170: {
              items: 5
            }
          }
        });
      }

      // ODOMETER WAYPOINT HOOK
      if ($('.odometer').length) {
        $('.odometer').waypoint(function() {
          setTimeout(function() {
            $('#odometer1.odometer').html(22);
          }, 500);

          setTimeout(function() {
            $('#odometer2.odometer').html(6102);
          }, 1000);

          setTimeout(function() {
            $('#odometer3.odometer').html(18);
          }, 1500);

          setTimeout(function() {
            $('#odometer4.odometer').html(3144);
          }, 2000);
        }, {
          offset: 800,
          triggerOnce: true
        });
      }
    }
  }
};
</script>

<style scoped>
.main-site-layout {
  min-height: 100vh;
}
</style>

